module.exports = __webpack_public_path__ + "img/close_icon.d03a5b7e.svg";